import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import { zapsToBePaused as ZapsToBePausedData } from './types/zapsToBePaused';

export const zapsToBePausedQuery = gql`
  query zapsToBePaused($accountId: ID!, $planId: ID!) {
    zapsToBePaused(accountId: $accountId, planId: $planId) {
      id
    }
  }
`;

type Input = {
  accountId: number | string | undefined;
  planId: number | string | undefined;
};

export const useZapsToBePaused = ({ accountId, planId }: Input) => {
  const { data, loading, error } = useQuery<ZapsToBePausedData>(
    zapsToBePausedQuery,
    {
      skip: !accountId || !planId,
      variables: { accountId, planId },
      fetchPolicy: 'network-only',
    }
  );

  return {
    zaps: data?.zapsToBePaused ?? [],
    isLoading: loading,
    error: error ? 'There was an issue loading data. Please try again' : null,
  };
};
